<template>
  <div class="brandCard">
    <div v-if="isPartner" class="ntv-triangle"></div>
    <router-link :to="{name: 'organize', params: {brandName: brandSlug}}">
      <el-card>
        <div class="brandCardBody">
          <img :src="logoUrl">
        </div>
        <div class="brandCardFooter">
          <span style="font-size: 13px;">
            {{ name }}
          </span>
        </div>
      </el-card>
    </router-link>
  </div>
</template>

<script>
import ElCard from '../../../node_modules/element-ui/packages/card/src/main.vue'

export default {
  name: 'brand-card',

  components: {
    ElCard
  },

  props: {
    logoUrl: {
      type: String,
      required: true
    },
    brandSlug: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    features: {
      type: Array,
      required: false
    },
    isPartner: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style scoped lang="less">
  .brandCard {
    margin-bottom: 10px;
    margin-right: 10px;
    position: relative;
  }

  .brandCardBody {
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .brandCardFooter {
    margin-top: 10px;
    width: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .brandCardFooter span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ntv-triangle {
    width: 0px;
    height: 0px;
    border-color: #5acaec;
    border-top: 40px solid #5acaec;
    border-left: 40px solid white;
    border-bottom: 0px solid white;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 5;
  }
</style>
